import { cn } from "@babackapp/customer-ui/lib/utils";

export function Toolbar(props: React.ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "border p-1 px-2.5 bg-background rounded-lg flex items-center justify-end gap-2",
        "[&>svg]:size-4",
      )}
      {...props}
    />
  );
}

export function ToolbarTitle(props: React.ComponentProps<"span">) {
  return <span className="text-sm font-medium" {...props} />;
}
